import React from "react";
import { AutoResizeTextarea } from "@/components";

export const OtherEtcInfo = ({ formData, handleChange, setFormData, disabled }) => {
    const { memoForClient } = formData;

    return (
        <>
            {/* 메모 */}
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>메모</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <AutoResizeTextarea
                            name="memoForClient"
                            placeholder="메모를 작성해주세요."
                            value={memoForClient}
                            onChange={handleChange}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
